import React from "react";
import { Button } from "../../../../ui/button";
import { ChevronDown, ChevronLeft, ChevronRight } from "lucide-react";
import { Tooltip as MTooltip } from "@material-ui/core";
import moment from "moment/moment";
import { withoutEmptyKeys } from "../../../../../util/object";
import AllTransactionsFilter from "../../../AllTransactions/components/AllTransactionsFilter";
import { operations } from "../../../../../util/operationsForFilters";
import { HeaderFilterButton } from "../../../../RemarkTemplate/Body";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown, faBars } from "@fortawesome/fontawesome-free-solid";
import { Analitycs } from "../../../AllTransactions/components/Analitycs";

const FiltersInsuranceVerifications = (props) => {
  const {
    statusSelected,
    practiceSelected,
    handleClick,
    id,
    clientSelected,
    practiceSelectedLabel,
    changeCurrentDate,
    currentDate,
    togglePracticeModal,
    theme,
    filters,
    setFilters,
    setShowModalExport,
    setShowAnalytics,
    showAnalytics,
    dateFilter,
  } = props;

  return (
    <React.Fragment>
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center">
          <div className="flex items-center space-x-2 insurance-dates-filter">
            <span className="text-md  text-gray-600">
              {clientSelected?.client[0]?.name || "Not found client"} -{" "}
              {practiceSelectedLabel}
            </span>{" "}
            <span className="text-lg ml-3">•</span>
            <div className="flex items-center space-x-2">
              <Button
                variant="ghost"
                size="sm"
                onClick={() => changeCurrentDate("previous")}
                className="ghost-white"
              >
                <ChevronLeft className="w-4 h-4" color="rgb(17 24 39)" />
              </Button>
              <span className="text-md text-gray-600">
                {currentDate
                  ? moment(currentDate).format("MM/DD/YYYY")
                  : "Loading..."}
              </span>
              <Button
                variant="ghost"
                size="sm"
                onClick={() => changeCurrentDate("next")}
                className="ghost-white"
              >
                <ChevronRight className="w-4 h-4 " color="rgb(17 24 39)" />
              </Button>
            </div>
          </div>
        </div>
        <Button
          className={`!bg-teal-600 hover:bg-teal-800 text-white !rounded-xl !h-9`}
          onClick={() => togglePracticeModal()}
        >
          Show
        </Button>
      </div>

      <div className="bg-white rounded-xl border border-gray-200 p-6 mb-6">
        <div className="flex items-center gap-4 justify-between insurance-dates-filter">
          <div className="flex items-center space-x-4 w-full">
            <Button
              aria-describedby={id}
              size="sm"
              variant="outline"
              className="min-w-[150px] !rounded-xl !px-5 !py-5 !flex items-center !justify-between !gap-[2rem] !text-gray-600 !hover:bg-accent !hover:text-accent-foreground !focus:outline-none !focus:ring-2 !focus:ring-ring !focus:ring-offset-2 transactions-select-button"
              onClick={(ev) => {
                ev.stopPropagation();
                handleClick(ev, "practices");
              }}
            >
              {practiceSelected} <ChevronDown className="w-4 h-4" />
            </Button>

            <Button
              aria-describedby={id}
              size="sm"
              variant="outline"
              className="!rounded-xl !px-5 !py-5 items-center !justify-between !gap-[2rem] !text-gray-600 !hover:bg-accent !hover:text-accent-foreground transactions-select-button !hidden"
              onClick={(ev) => {
                ev.stopPropagation();
                handleClick(ev, "status");
              }}
            >
              {statusSelected} <ChevronDown className="w-4 h-4" />
            </Button>
          </div>

          <div>
            <MTooltip title="Show Analytics" placement="top">
              <div
                className="d-flex align-items-center justify-content-center pointer"
                style={{
                  width: 30,
                  height: 30,
                  borderRadius: "50%",
                  background: "#136C62",
                  color: "white",
                }}
                onClick={() => setShowAnalytics(true)}
              >
                <FontAwesomeIcon icon={faBars} />
              </div>
            </MTooltip>
          </div>
          <div>
            <MTooltip title="Export to Excel" placement="top">
              <div
                className="d-flex align-items-center justify-content-center pointer"
                style={{
                  width: 30,
                  height: 30,
                  borderRadius: "50%",
                  background: "#136C62",
                  color: "white",
                }}
                onClick={() => setShowModalExport(true)}
              >
                <FontAwesomeIcon icon={faArrowDown} />
              </div>
            </MTooltip>
          </div>
          <HeaderFilterButton
            active={
              filters && Object.keys(withoutEmptyKeys(filters)).length > 0
            }
            render={AllTransactionsFilter}
            componentProps={{
              setFilters,
              initialData: filters,
              operations,
              module_key: "AT",
              theme,
              dateFilter,
            }}
            theme={theme}
            isButtonIcon={false}
            text="Filters"
          />
        </div>

        {showAnalytics && <Analitycs filters={filters} theme={theme} />}
      </div>
    </React.Fragment>
  );
};

export default FiltersInsuranceVerifications;
